export enum FilterComponentEvents {
  CLOSE_FILTER = 'closeFilter',
  RESET_FILTER = 'resetFilter',
  SUBMIT_FILTER = 'submitFilter',
}
